import { apiClient } from './client';

export interface RefundRequestMutationResponse {
  success: boolean;
  status: number;
  data: {
    refund_request_id: string;
    status: string;
    request_type?: string;
    next_reminder_at?: string | null;
  };
}

export const requestRefundByTransaction = async (
  transactionId: string
): Promise<RefundRequestMutationResponse> => {
  const response = await apiClient.post(`/refund-requests/refund/${transactionId}`);
  return response.data;
};

export const reportDoubleChargeByTransaction = async (
  transactionId: string
): Promise<RefundRequestMutationResponse> => {
  const response = await apiClient.post(
    `/refund-requests/double-charge/${transactionId}`
  );
  return response.data;
};

export const cancelRefundRequestById = async (
  refundRequestId: string
): Promise<RefundRequestMutationResponse> => {
  const response = await apiClient.post(
    `/refund-requests/${refundRequestId}/cancel`
  );
  return response.data;
};

export const remindStoreByRefundRequestId = async (
  refundRequestId: string
): Promise<RefundRequestMutationResponse> => {
  const response = await apiClient.post(
    `/refund-requests/${refundRequestId}/remind`
  );
  return response.data;
};
